import {createApp, h, VNode} from "vue";

import Popup from "../components/popup.vue";
export type SlotContentGenerator = () => VNode | VNode[] | string | null; // <--- 定义在这里

export function openAds(id=0, contentGenerator?: SlotContentGenerator,props = {}) {
    const adKey = `ad-${id}`; // 使用 id 作为标识符
    const adSeen = localStorage.getItem(adKey);

    // 如果广告已经看过，直接返回，不显示广告
    if (adSeen) {
        console.log("广告已经看过，不显示");
        return;
    }


    const dialog = document.createElement('div');
    document.body.appendChild(dialog);

    // 创建自定义弹窗容器
    const dialogApp = createApp({
        // 修改这里，使用 TSX 语法
        render() {
            return (
                <Popup
                    style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        maxWidth: '800px',
                        zIndex: 1000,
                    }}
                    onClose={() => {
                        localStorage.setItem(adKey, 'seen');
                        dialogApp.unmount();
                        document.body.removeChild(dialog);
                    }}
                    {...props}
                >
                    {contentGenerator ? contentGenerator() : (
                        <div  style={{
                            fontSize: `${computedFontSize(t(card.title, card.prop), 5, 6)}dvh`,
                            userSelect: 'none',
                            display: 'flex',
                            flexDirection: 'row', // 注意：你的注释是“垂直排列”，但代码是 'row'
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                        }}>
                            {/* 你的内容 */}
                            <div>这是默认的广告内容。</div>
                            <p>你可以通过函数传递自定义内容。</p>
                        </div>
                    )}
                </Popup>
            );
        }
    });

    dialogApp.mount(dialog);
}

